import React, { useState, createContext, useContext } from "react";
import { useReactFlow } from "reactflow";

import { createGraphLayout } from "../util/graphUtils";

const AutoLayoutContext = createContext();

const AutoLayoutProvider = ({ children }) => {
  const [autoLayoutOn, setAutoLayoutOn] = useState(true);

  const { getNodes, getEdges, setNodes, setEdges } = useReactFlow();

  // use useEffect in the case of adding/removing new nodes
  const autoLayout = async () => {
    const loadedNodes = getNodes();
    const loadedEdges = getEdges();
    const { layoutedNodes, layoutedEdges } = createGraphLayout(
      loadedNodes,
      loadedEdges
    );
    setNodes(layoutedNodes);
    setEdges(layoutedEdges);
  };

  return (
    <AutoLayoutContext.Provider
      value={{ autoLayout, autoLayoutOn, setAutoLayoutOn }}
    >
      {children}
    </AutoLayoutContext.Provider>
  );
};

export const useAutoLayoutContext = () => useContext(AutoLayoutContext);
export default AutoLayoutProvider;
